import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HistoryTable, EarningsTable } from "./";
import Tabs from "react-responsive-tabs";
import style from "./codeactive.module.scss";
import { useSelector } from "react-redux";

const stylees = {
  paddingTop: "10px",
  fontFamily: "system-ui",
};

function Content({
  tableData,
  changeHandler,
  paginationHandler,
  repurchase_status,
  exportData,
  selectedTab,
  loader,
  state,
}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();

  const [tabs, setTabs] = useState([]);
  const [selectedTabKey, setSelectedTabKey] = useState("activationCodeHistory");

  useEffect(() => {
    const newTabs = [];
    if (state.activationHistory) {
      newTabs.push("activationCodeHistory");
    }
    if (state.downlineActivationHistory) {
      newTabs.push("earningCodeActive");
    }
    if (newTabs.length === 0 && state.downlineActivationHistory) {
      newTabs.push("earningCodeActive");
    }
    setTabs(newTabs);

    // Set the default selected tab key
    if (newTabs.includes("activationCodeHistory")) {
      setSelectedTabKey("activationCodeHistory");
    } else if (newTabs.includes("earningCodeActive")) {
      setSelectedTabKey("earningCodeActive");
    }
  }, [state.activationHistory, state.downlineActivationHistory]);

  const getTabs = () => {
    return tabs.map((tab, index) => ({
      title: t("Common." + tab),
      getContent: () => getContent(tab),
      key: tab,
      tabClassName: style.TabClass,
      panelClassName: style.TabPanel,
    }));
  };

  const getContent = (contentId) => {
    if (contentId === "earningCodeActive") {
      return (
        <div className={style.dataTable} style={stylees}>
          <EarningsTable
            loader={loader}
            ContentData={tableData.earnings}
            paginationchange={paginationHandler.earnings}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    } else if (contentId === "activationCodeHistory") {
      return (
        <div className={style.dataTable} style={stylees}>
          <HistoryTable
            loader={loader}
            ContentData={tableData.history}
            paginationchange={paginationHandler.history}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    }
  };

  return (
    <div className={style.summary}>
      <div
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_tabContent}`
            : `${style.tabContent}`
        }`}
      >
        <Tabs
          items={getTabs()}
          transform={true}
          transformWidth={734}
          onChange={changeHandler}
          selectedTabKey={selectedTabKey}
        />
      </div>
    </div>
  );
}

export default Content;
